export default __webpack_public_path__ + "static/media/clientes03.e1de54bf.png";